import { render, staticRenderFns } from "./PopupBubble.vue?vue&type=template&id=7aa65fc0&scoped=true"
import script from "./PopupBubble.vue?vue&type=script&lang=js"
export * from "./PopupBubble.vue?vue&type=script&lang=js"
import style0 from "./PopupBubble.vue?vue&type=style&index=0&id=7aa65fc0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aa65fc0",
  null
  
)

export default component.exports